import React from 'react';
import Link from 'found/lib/Link';

import FacebookIcon from 'components/icons/Facebook';
import TwitterIcon from 'components/icons/Twitter';
import InstagramIcon from 'components/icons/Instagram';
// import PinterestIcon from 'components/icons/Pinterest';

import styles from './index.scss';

export default () => (
  <div className={styles.container}>
    <div className={styles.row}>
      <div className={styles.col}>
        <a
          rel='noopener noreferrer'
          aria-label='Facebook'
          target='_blank'
          title='Facebook'
          href='https://www.facebook.com/ripplestreetfun'
        >
          <FacebookIcon color='#ffffff' className={styles.icon} />
        </a>
        <a
          rel='noopener noreferrer'
          aria-label='Twitter'
          target='_blank'
          title='X'
          href='https://twitter.com/ripplestreetfun'
        >
          <TwitterIcon color='#ffffff' className={styles.icon} />
        </a>
        <a
          rel='noopener noreferrer'
          aria-label='Instagram'
          target='_blank'
          title='Instagram'
          href='https://www.instagram.com/ripplestreetfun'
        >
          <InstagramIcon color='#ffffff' className={styles.icon} />
        </a>
        {/* <a
          rel='noopener noreferrer'
          aria-label='Pinterest'
          target='_blank'
          title='Pinterest'
          href='https://www.pinterest.com/ripplestreetfun'
        >
          <PinterestIcon
            color='#ffffff'
            style={{ marginRight: 0 }}
            className={styles.icon}
          />
        </a> */}
      </div>
    </div>
    <div className={styles.row}>
      <div className={styles.col}>
        <a
          className={styles.links}
          rel='noopener noreferrer'
          href='https://about.ripplestreet.com'
          target='_blank'
        >
          About Us
        </a>
      </div>
      |
      <div className={styles.col}>
        <Link className={styles.links} to='/privacy-policy'>Privacy Policy</Link>
      </div>
      |
      <div className={styles.col}>
        <Link className={styles.links} to='/terms-of-service'>Terms of Service</Link>
      </div>
      |
      {/* <div className={styles.col}>
        <Link to='/code-of-conduct'>Code of Conduct</Link>
      </div> */}
      <div className={styles.col}>
        <a
          rel='noopener noreferrer'
          target='_blank'
          href='https://help.ripplestreet.com'
          className={styles.links}
        >
          Help
        </a>
      </div>
    </div>
    <div className={styles.row}>
      <div className={styles.col}>
        &copy;{new Date().getFullYear()} Ripple Street
      </div>
    </div>
  </div>
);
